<template>
  <div>
    <customize-page label-position="left" ref="page" inline :loading="loading" :data="dataList" :columns="columns"
      :pagination="pagination" :formConfig="getFormConfig()" :filterObj="filterObj" @size-change="handleSizeChange"
      @on-selection-change="selectionChange" @current-change="handleCurrentChange">
      <div slot="footer">
        <el-button size="mini" type="primary" @click="search"> 搜索 </el-button>
        <el-button size="mini" @click="reset">重置</el-button>
      </div>
    </customize-page>
  </div>
</template>

<script>
import CustomizePage from "@/components/customize-page";
import Page from "@/mixin/Page";

import { mapGetters, mapState } from "vuex";
import { CONST_VD_IMGPREFIX } from "@/config/constant";
import shopAuthApi from "@/api/shopAuthApi";
import authApi from "@/api/auth";
import declareApi from "@/api/declare";
import moment from "moment";

export default {
  components: {
    CustomizePage,
  },
  mixins: [Page],
  created() {
    authApi.getOmsUserInfo().then((res) => {
      this.userInfo = res;
      this.fetch();
      this.fetchAllShop();
    });
  },
  data() {
    return {
      userInfo: {},
      loading: false,
      dataList: [],
      shopList: [],
      successInfos: [],
      failInfos: [],
      columns: [
        {
          type: "selection",
          width: 50,
          align: "center",
          fixed: "left",
        },
        {
          fixed: "left",
          title: "操作",
          width: 100,
          align: "center",
          render: (h, params) => {
            return (
              <div>
                {this.$hasPermission(this.$route, "cancelStockout") &&
                  ["已出库", "已取消"].indexOf(params.row.stateStr) < 0 ? (
                  <el-button
                    type="text"
                    onClick={this.handleCancelOrder.bind(this, params.row)}
                  >
                    取消出库
                  </el-button>
                ) : (
                  ""
                )}
              </div>
            );
          },
        },
        {
          title: "平台订单号",
          width: 260,
          fixed: "left",
          key: "merchantOrderNo",
          align: "center",
          render: (h, params) => {
            let bizId = params.row.bizId;
            return (
              <div>
                <a
                  style="color:blue"
                  onClick={this.showDetail.bind(this, bizId)}
                >
                  {params.row.originMerchantOrderNo}
                </a>
              </div>
            );
          },
        },
        {
          title: "所属平台",
          width: 100,
          key: "merchantName",
          align: "center",
        },
        {
          title: "店铺",
          width: 220,
          key: "subChannelName",
          align: "center",
          render: (h, params) => {
            return (
              <div>
                <div>{params.row.subChannelName}</div>
                <div>{params.row.subChannelCode}</div>
              </div>
            );
          },
        },
        {
          title: "出库状态",
          width: 120,
          key: "stateStr",
          align: "center",
        },
        {
          title: "仓库操作状态",
          width: 160,
          key: "wmsOperationStatus",
          align: "center",
          render: (h, params) => {
            return (
              <div>
                <div>
                  {this.wmsOperationStatusMap[params.row.wmsOperationStatus]}
                </div>
                <div>{params.row.wmsOperationTime}</div>
              </div>
            );
          },
        },
        {
          title: "是否异常",
          width: 120,
          align: "center",
          render: (h, params) => {
            const isException = !!params.row.exceptionMsg;
            return isException ? (
              <div>
                <el-popover
                  placement="top-start"
                  width="200"
                  trigger="hover"
                  content={params.row.exceptionMsg}
                >
                  <el-tag type="danger" slot="reference">
                    异常
                  </el-tag>
                </el-popover>
              </div>
            ) : null;
          },
        },
        {
          title: "是否下发wms",
          width: 120,
          key: "isWmsSend",
          align: "center",
          render: (h, params) => {
            let isWmsSend = params.row.isWmsSend;
            const tagType = isWmsSend ? "success" : "info";
            return (
              <div>
                <el-tag type={tagType}>
                  {isWmsSend ? "已下发" : "未下发"}
                </el-tag>
              </div>
            );
          },
        },
        // ...lowDeclareColumn,
        //清单申报
        {
          title: "是否申报清单",
          width: 120,
          key: "ccbIsDeclareStr",
          align: "center",
        },
        {
          title: "清关状态",
          width: 120,
          key: "ccbState",
          align: "center",
          render: (h, param) => {
            let row = param.row;
            // if(row.ccbBizState==="800"){
            let state = row.ccbState;
            return (
              <div>
                <el-tooltip className="item" effect="light" placement="top">
                  <div slot="content">{row.ccbStateDesc}</div>
                  <el-button>{state}</el-button>
                </el-tooltip>
              </div>
            );
            //}
            //return <div>{row.ccbBizRemark}</div>;
          },
        },
        {
          title: "清单编号",
          width: 200,
          key: "ccbBizId",
          align: "center",
        },
        {
          title: "清单申报时间",
          width: 180,
          key: "ccbSendTimeStr",
          align: "center",
        },
        {
          title: "清单回执时间",
          width: 180,
          key: "ccbReturnTimeStr",
          align: "center",
        },

        //运单申报
        {
          title: "是否申报运单",
          width: 130,
          key: "tplIsDeclareStr",
          align: "center",
        },
        {
          title: "运单状态",
          width: 150,
          key: "tplState",
          align: "center",
          render: (h, param) => {
            let row = param.row;
            // if(row.ccbBizState==="800"){
            let state = row.tplState;
            return (
              <div>
                <el-tooltip className="item" effect="light" placement="top">
                  <div slot="content">{row.tplStateDesc}</div>
                  <el-button>{state}</el-button>
                </el-tooltip>
              </div>
            );
            //}
            //return <div>{row.ccbBizRemark}</div>;
          },
        },
        {
          title: "运单申报时间",
          width: 180,
          key: "tplSendTimeStr",
          align: "center",
        },
        {
          title: "运单回执时间",
          width: 180,
          key: "tplReturnTimeStr",
          align: "center",
        },
        {
          title: "承运商",
          width: 120,
          key: "carrierName",
          align: "center",
        },
        {
          title: "运单号",
          width: 200,
          key: "mailNo",
          align: "center",
        },

        //订单申报
        {
          title: "是否申报订单",
          width: 130,
          key: "orderIsDeclareStr",
          align: "center",
        },
        {
          title: "订单状态",
          width: 150,
          key: "orderState",
          align: "center",
          render: (h, param) => {
            let row = param.row;
            // if(row.ccbBizState==="800"){
            let state = row.orderState;
            return (
              <div>
                <el-tooltip className="item" effect="light" placement="top">
                  <div slot="content">{row.orderStateDesc}</div>
                  <el-button>{state}</el-button>
                </el-tooltip>
              </div>
            );
            //}
            //return <div>{row.ccbBizRemark}</div>;
          },
        },
        {
          title: "订单申报时间",
          width: 180,
          key: "orderSendTimeStr",
          align: "center",
        },
        {
          title: "订单回执时间",
          width: 180,
          key: "orderReturnTimeStr",
          align: "center",
        },
        {
          title: "创建时间",
          width: 180,
          key: "gmtCreate",
          align: "center",
        },
      ],
      filterObj: {
        merchantOrderNo: "",
        invtNo: "",
        bizId: "",
        state: "WAIT_STOCKOUT",
        applyTime: [],
        gmtCreate: [
          new Date(
            parseFloat(
              moment()
                .subtract(3, "day")
                .startOf("day")
                .format("x")
            )
          ),
          new Date(
            parseFloat(
              moment()
                .endOf("day")
                .format("x")
            )
          ),
        ],
      },
      currentRow: [],
      sortObj: {},
      customsType: {
        ccb: "ccb",
        tpl: "tpl",
        wms: "wms",
        mail: "mail",
        low: "low",
        port: "port",
      },
      reCustomsDeclare: {
        msg: "",
        title: "重推",
        isReApply: false,
        currentReApplyData: [],
        successNum: 0,
        total: 0,
      },
    };
  },
  computed: {
    ...mapState("cs", {
      carrierAllList: "carrierAllList",
    }),
    ...mapState("channelStore", {
      allChannelList: "allChannelList",
    }),
    ...mapGetters(["wmsOperationStatusMap"]),
  },
  methods: {
    handleCancelOrder(row) {
      this.$confirm(
        `此操作将取消出库单:${row.originMerchantOrderNo}, 是否继续?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        let bizId = row.bizId;
        this.loading = true;
        declareApi
          .cancelOrder({ request: { bizIds: [bizId] } })
          .then((res) => {
            if (res.value) {
              this.$message({
                message: "取消成功",
                type: "success",
              });
            } else {
              this.$message({
                message: "取消失败",
                type: "error",
              });
            }
            this.loading = false;

            this.fetch();
          })
          .catch(() => {
            this.loading = false;
          });
      });
    },
    fetch() {
      this.loading = true;
      const filterParams = this.getFilterParams();
      if (filterParams.applyTime != null) {
        filterParams.declarePassGmtStart = filterParams.applyTime[0];
        filterParams.declarePassGmtEnd = filterParams.applyTime[1];
        //delete filterParams.applyTime;
      } else {
        delete filterParams.declarePassGmtStart;
        delete filterParams.declarePassGmtEnd;
      }

      if (filterParams.gmtCreate != null) {
        filterParams.gmtCreateStart = moment(filterParams.gmtCreate[0]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        filterParams.gmtCreateEnd = moment(filterParams.gmtCreate[1]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        delete filterParams.gmtCreate;
      } else {
        delete filterParams.gmtCreateStart;
        delete filterParams.gmtCreateEnd;
      }

      if (this.userInfo.customerId) {
        filterParams.customerId = this.userInfo.customerId;
      }

      if (!filterParams.gmtCreateStart) {
        if (
          !filterParams.originMerchantOrderNo &&
          !filterParams.mailNo &&
          filterParams.state !== "WAIT_STOCKOUT"
        ) {
          this.$message.warning({
            message:
              "查询条件至少要有以下一个:平台订单号、运单号、出库状态为待出库",
            duration: 5000,
          });
          this.loading = false;
          return;
        }
      }

      const sortObj = this.sortObj;

      let searchCondition = {
        ...sortObj,
        request: {
          condition: filterParams,
          pageIndex: this.pagination.currentPage,
          pageSize: this.pagination.pageSize,
        },
      };

      this.$store.dispatch("sc", {
        page: "customsDeclareList",
        param: searchCondition,
      });
      let __this = this;
      this.$store
        .dispatch("queryDeclareOrderList", searchCondition)
        .then((res) => {
          this.loading = false;
          this.dataList = res.items || [];
          const pageInfo = res.page || { totalCount: 0 };
          this.pagination.totalCount = pageInfo.totalCount;
        });
    },
    selectionChange(rows) {
      this.currentRow = rows;
    },
    fetchAllShop() {
      return shopAuthApi
        .listAll()
        .then((res) => {
          this.shopList = res.items
            .filter((item) => {
              if (!this.userInfo.customerId) {
                return true;
              }
              return item.customerId === this.userInfo.customerId;
            })
            .map((res) => {
              return {
                label: res.shopName,
                value: res.shopCode,
                type: res.shopType,
              };
            });
        })
        .catch(() => {
          this.$message.error("店铺列表加载失败，请刷新页面重试");
        });
    },
    getFormConfig() {
      const type = this.getFormItemType();
      let subChannelSearchConditionConfig = [];
      let originMerchantOrderNoColumn = [];
      if (
        CONST_VD_IMGPREFIX.env == "NC" ||
        CONST_VD_IMGPREFIX.env === "SHANGHAI"
      ) {
        subChannelSearchConditionConfig.push({
          label: "店铺",
          model: "subBizType",
          type: type.SELECT,
          props: {
            data: this.shopList,
          },
        });
      }
      if (CONST_VD_IMGPREFIX.env === "SHANGHAI") {
        originMerchantOrderNoColumn.push({
          label: "平台订单号",
          model: "originMerchantOrderNo",
          type: type.INPUT,
        });
      }

      return [
        {
          data: [
            ...originMerchantOrderNoColumn,
            {
              label: "清关状态",
              model: "ccbBizState",
              type: type.SELECT,
              multiple: true,
              props: {
                data: [
                  { value: "-1", label: "未回执" },
                  { value: "-2", label: "异常" },
                  { value: "1", label: "电子口岸已暂存" },
                  {
                    value: "2",
                    label: "电子口岸申报中",
                  },
                  { value: "3", label: "发送海关成功" },
                  {
                    value: "4",
                    label: "发送海关失败",
                  },
                  { value: "100", label: "海关退单" },
                  {
                    value: "120",
                    label: "海关入库",
                  },
                  { value: "300", label: "人工审核" },
                  {
                    value: "399",
                    label: "海关审结",
                  },
                  { value: "800", label: "放行" },
                  {
                    value: "899",
                    label: "结关",
                  },
                  { value: "500", label: "查验" },
                  {
                    value: "501",
                    label: "扣留移送通关",
                  },
                  { value: "502", label: "扣留移送缉私" },
                  {
                    value: "503",
                    label: "扣留移送法规",
                  },
                  { value: "599", label: "其它扣留" },
                  { value: "700", label: "退运" },
                ],
              },
            },
            {
              label: "订单渠道",
              model: "orderSource",
              type: type.SELECT,
              props: {
                data: this.allChannelList,
              },
            },
            {
              label: "运单号",
              model: "mailNo",
              type: type.INPUT,
            },
            {
              label: "创建时间",
              model: "gmtCreate",
              type: type.DATETIME_RRANGE,
              className: "flex-form-item",
              props: {
                clearable: false,
              },
            },
            {
              label: "出库状态",
              model: "state",
              type: type.SELECT,
              props: {
                data: [
                  {
                    value: "",
                    label: "全部",
                  },
                  {
                    value: "WAIT_STOCKOUT",
                    label: "待出库",
                  },
                  {
                    value: "STOCKOUTING",
                    label: "出库中",
                  },
                  {
                    value: "STOCKOUT_FINISH",
                    label: "已出库",
                  },
                  {
                    value: "STOCKOUT_CANCEL",
                    label: "已取消",
                  },
                ],
              },
            },
            {
              label: "wms操作状态",
              model: "wmsOperationStatus",
              type: type.SELECT,
              props: {
                data: Object.keys(this.wmsOperationStatusMap).map((v) => {
                  return { value: v, label: this.wmsOperationStatusMap[v] };
                }),
              },
            },
            ...subChannelSearchConditionConfig,
            {
              label: "料号",
              model: "itemNo",
              type: type.INPUT
            }
          ],
        },
      ];
    },
    showDetail(id) {
      this.$router.push({
        name: "customerDeclareOrderDetail",
        params: { id },
      });
    },
  },
};
</script>
